import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

export default function Login() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ username: '', password: '', name: '', role: 'player', country: '', playerPhone: '', playerEmail: '', playerAge: '', orgName: '', orgPhone: '', orgEmail: '', orgCity: '' });
  const [error, setError] = useState('');
  const { login, register } = useApp();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setError('');
    if (mode === 'login') {
      const result = await login(form.username, form.password);
      if (result.success) navigate(result.user.role === 'admin' ? '/admin' : result.user.role === 'organizer' ? '/organizer' : '/');
      else setError(result.message);
    } else {
      if (!form.name.trim()) { setError('Name is required'); return; }
      if (form.role === 'player') {
        if (!form.playerPhone.trim()) { setError('Phone number is required'); return; }
        if (!form.playerEmail.trim()) { setError('Email is required'); return; }
        if (!form.country.trim()) { setError('City is required'); return; }
      }
      if (form.role === 'organizer') {
        if (!form.orgName.trim()) { setError('Organization name is required'); return; }
        if (!form.orgPhone.trim()) { setError('Phone number is required'); return; }
        if (!form.orgEmail.trim()) { setError('Email is required'); return; }
        if (!form.orgCity.trim()) { setError('City is required'); return; }
      }
      const result = await register(form.username, form.password, form.name, form.role, form.country, form.role === 'organizer' ? { orgName: form.orgName.trim(), orgPhone: form.orgPhone.trim(), orgEmail: form.orgEmail.trim(), orgCity: form.orgCity.trim() } : null, form.role === 'player' ? { phone: form.playerPhone.trim(), email: form.playerEmail.trim(), age: form.playerAge ? parseInt(form.playerAge) : null } : null);
      if (result.success) navigate(result.user.role === 'organizer' ? '/organizer' : '/');
      else setError(result.message);
    }
  };
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <div style={s.formTop}>
          <span style={s.dot}>●</span>
          <span style={s.brand}>TennisBuzz</span>
        </div>
        <h2 style={s.title}>{mode === 'login' ? 'Sign In' : 'Create Account'}</h2>
        <p style={s.hint}>Tennis tournament platform for players and organizers</p>
        {error && <div style={s.error}>{error}</div>}
        {mode === 'register' && (
          <>
            <label className="form-label" style={{ marginTop: 12 }}>I want to</label>
            <div style={s.roleRow}>
              {[{ val: 'player', label: 'Play in Tournaments' }, { val: 'organizer', label: 'Organize Events' }].map(r => (
                <button key={r.val} type="button" onClick={() => set('role', r.val)}
                  style={{ ...s.roleBtn, ...(form.role === r.val ? s.roleBtnActive : {}) }}>
                  {r.label}
                </button>
              ))}
            </div>
            {form.role === 'player' && (
              <>
                <div className="form-section" style={{ marginTop: 14 }}>Player Details</div>
                <label className="form-label">Full Name *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Anand Rathi" required />
                <label className="form-label">Phone Number *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} type="tel" value={form.playerPhone} onChange={e => set('playerPhone', e.target.value)} placeholder="+91 98765 43210" required />
                <label className="form-label">Email *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} type="email" value={form.playerEmail} onChange={e => set('playerEmail', e.target.value)} placeholder="player@email.com" required />
                <label className="form-label">City *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} value={form.country} onChange={e => set('country', e.target.value)} placeholder="e.g. Pune" required />
                <label className="form-label">Age</label>
                <input className="form-input" style={{ fontSize: 14 }} type="number" min="5" max="99" value={form.playerAge} onChange={e => set('playerAge', e.target.value)} placeholder="e.g. 25" />
              </>
            )}
            {form.role === 'organizer' && (
              <>
                <div className="form-section" style={{ marginTop: 14 }}>Organizer Details</div>
                <label className="form-label">Full Name *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Rajesh Kumar" required />
                <label className="form-label">Organization / Club Name *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} value={form.orgName} onChange={e => set('orgName', e.target.value)} placeholder="e.g. Pune Tennis Academy" required />
                <label className="form-label">Phone Number *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} type="tel" value={form.orgPhone} onChange={e => set('orgPhone', e.target.value)} placeholder="+91 98765 43210" required />
                <label className="form-label">Email *</label>
                <input className="form-input" style={{ fontSize: 14, marginBottom: 8 }} type="email" value={form.orgEmail} onChange={e => set('orgEmail', e.target.value)} placeholder="organizer@email.com" required />
                <label className="form-label">City *</label>
                <input className="form-input" style={{ fontSize: 14 }} value={form.orgCity} onChange={e => set('orgCity', e.target.value)} placeholder="e.g. Pune" required />
              </>
            )}
          </>
        )}
        <label className="form-label" style={{ marginTop: 12 }}>Username</label>
        <input className="form-input" style={{ fontSize: 14 }} value={form.username} onChange={e => set('username', e.target.value)} required />
        <label className="form-label" style={{ marginTop: 12 }}>Password</label>
        <input className="form-input" style={{ fontSize: 14 }} type="password" value={form.password} onChange={e => set('password', e.target.value)} required />
        <button type="submit" className="btn-primary" style={{ width: '100%', padding: 13, fontSize: 14, marginTop: 16 }}>{mode === 'login' ? 'Sign In' : 'Create Account'}</button>
        <p style={s.toggle}>
          {mode === 'login' ? "Don't have an account?" : 'Already have an account?'}{' '}
          <button type="button" onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }} style={s.toggleBtn}>
            {mode === 'login' ? 'Register' : 'Sign In'}
          </button>
        </p>
      </form>
    </div>
  );
}

const s = {
  container: { minHeight: 'calc(100vh - 52px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F8F9FC', padding: 16 },
  form: { background: '#fff', padding: '28px 24px 24px', borderRadius: 16, border: '1px solid #EEF1F6', width: '100%', maxWidth: 420, boxShadow: '0 8px 32px rgba(0,32,91,0.08)' },
  formTop: { display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', marginBottom: 16 },
  dot: { color: '#BDFF00', fontSize: 8 },
  brand: { fontSize: 12, fontWeight: 800, color: '#00205B', letterSpacing: 2.5, fontFamily: "'Outfit', sans-serif" },
  title: { textAlign: 'center', marginBottom: 4, color: '#00205B', fontFamily: "'Outfit', sans-serif", fontSize: 22, fontWeight: 700 },
  hint: { textAlign: 'center', color: '#B0B8C9', fontSize: 11, marginBottom: 20, lineHeight: 1.5 },
  error: { background: '#FFEBEE', color: '#C62828', padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: 12, textAlign: 'center', fontWeight: 500 },
  toggle: { textAlign: 'center', marginTop: 16, fontSize: 13, color: '#8892A6' },
  toggleBtn: { background: 'none', border: 'none', color: '#00205B', fontWeight: 700, cursor: 'pointer', fontSize: 13 },
  roleRow: { display: 'flex', gap: 8 },
  roleBtn: { flex: 1, padding: '12px 8px', border: '1.5px solid #D8DDE8', borderRadius: 8, background: '#F8F9FC', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#5F6B80', textAlign: 'center' },
  roleBtnActive: { borderColor: '#00205B', background: 'rgba(0,32,91,0.04)', color: '#00205B' },
};
